import React from 'react';
import { Button } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { DeleteMicContainer } from './DeleteMicContainer';
import { FormMicContainer } from './FormMicContainer';
import { Dialog } from 'primereact/dialog';

export const ModalMicContainers = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        name_container, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete,
        closeDialog
    } = props;

    return (
        <Dialog
            //header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-pen-holder-alt-1 f-24 "></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v38 `}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >
            {
                method === "create"
                    ?
                    <FormMicContainer
                        button={ModalButtonSave}
                        {...{ toggle, loading, handleInputChange, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicContainer
                            button={ModalButtonUpdate}
                            {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveUpdate, name_container, }}
                        />
                        :
                        <DeleteMicContainer
                            {...{ toggle, loading, name_container, saveDelete }}
                        />
            }
        </Dialog>
    )
}
